import { Routes } from '@angular/router';

/**
 * Routes that exist ONLY in the `e2e` build configuration: `angular.json` swaps
 * this file for `harness.routes.e2e.ts` there. Every deployed build (production,
 * w4u, local, development) compiles this empty list, so the harness pages are
 * never shipped. See `e2e/comment-bubble.e2e.spec.ts`.
 */
export const harnessRoutes: Routes = [];
